import * as React from 'react';
const Earnings = ({ fillPath, ...restProps }: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={28} height={28} fill="none" {...restProps}>
    <mask
      id="a"
      width={28}
      height={28}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h28v28H0z" />
    </mask>

    <path
      fill={fillPath || '#003594'}
      d="M9.737 15.117V7.404h2.692v7.713l-1.346-1.297-1.346 1.297Zm5.452 2.177V2.737h2.692v11.864l-2.692 2.693ZM4.263 20.556V12.07h2.692v5.792l-2.692 2.693Zm-.068 3.71 6.852-6.851 4.142 3.558 7.206-7.206h-2.27v-1.75h5.25v5.25h-1.75v-2.27L15.26 23.36l-4.142-3.558-4.465 4.465H4.195Z"
    />
  </svg>
);
export default Earnings;
